import React, { useEffect, useContext } from "react";
import useState from "react-usestateref";
import Header from "./Header";
import Sidebar from "./Sidebar";
import { Link } from "react-router-dom";
import authservices from "../services/authservices";
import { ScaleLoader } from "react-spinners";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";

function FAQ() {
  const [faqType, setFaqType] = useState("Trade");
  const [faqs, setFaqs] = useState({});
  const { t } = useTranslation();

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);
  
  
  const faqCategories = [
    { key: "Trade", label: "Trade" },
    { key: "Deposit", label: "Deposit" },
    { key: "Withdraw", label: "Withdraw" },
    { key: "API Bind", label: "API Bind" },
    { key: "Team Management", label: "Team Management" },
    { key: "Trading Bots", label: "Trading Bots" },
    { key: "Strategies", label: "Strategies" },
    { key: "Risk and Fraud", label: "Risk and Fraud" },
  ];
  const [openFaq, setOpenFaq] = useState(null); // Track open question
  const [loading, setLoading] = useState(true);

  // Toggle FAQ open/close
  const toggleFaq = (faqId) => {
    setOpenFaq((prev) => (prev === faqId ? null : faqId));
  };

  const fetchFaqs = async () => {
    try {
      const response = await authservices.getFaq();
      if (response.status) {
        const groupedFaqs = response.data
          .filter((faq) => faq.type === "FAQ")
          .reduce((acc, faq) => {
            const { category } = faq;
            if (!acc[category]) acc[category] = [];
            acc[category].push(faq);
            return acc;
          }, {});
        setFaqs(groupedFaqs);
        const firstCategory = Object.keys(groupedFaqs)[0];
        if (firstCategory) {
          setFaqType(firstCategory);
        }
        setLoading(false);
      } else {
        // console.error("Failed to fetch FAQs");
        setLoading(false);
      }
    } catch (error) {
      // console.error("Error fetching FAQs:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFaqs();
  }, [0]);

  return (
    <div>
      <section>
        <Header />
      </section>
      <div className="">
        <div className="container">
          <div className="row prof_row_sm">
            <div className="col-lg-3 dispaly_none_1200">
              <Sidebar />
            </div>
            <div className="col-xl-9 col-lg-12 deposit_pad_top">
              <span className="profile_span">{t("FAQs")}</span>
              {loading ? (
                <div className="loader_main loader_mainChange">
                  <ScaleLoader color="#20A1FD" height={10} width={3} />
                  <p>{t("Loading")}</p>
                </div>
              ) : (
                <>
                  <div className="faq_resp_changed_mainright mt-3">
                    <div className="faq_col2_main h-100">
                      <span className="faq_cate_span">{t("Categories")}</span>
                      <div className="mt-2 faq_categories">
                        {Object.keys(faqs).map((category) => (
                          <div
                            key={category}
                            className={
                              faqType === category
                                ? "faq_cate_main_active"
                                : "faq_cate_main"
                            }
                            onClick={() => setFaqType(category)}
                          >
                            <i className="fa-solid fa-chevron-right faq_cate_arrow"></i>
                            <span>{category}</span>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="faq_col10_main h-100">
                      {faqs[faqType] && faqs[faqType].length > 0 ? (
                        <div
                          className="accordion accordion-flush"
                          id="accordionFlushExample"
                        >
                          {faqs[faqType].map((faq, index) => (
                            <div
                              key={faq._id}
                              className="accordion-item-faq font-satoshi"
                            >
                              <h2
                                className="accordion-header"
                                id={`flush-heading-${index}`}
                              >
                                <button
                                  // className="accordion-button collapsed"
                                  className={`accordion-button ${
                                    openFaq === faq._id ? "" : "collapsed"
                                  }`}
                                  type="button"
                                  data-bs-toggle="collapse"
                                  // type="button"
                                  onClick={() => toggleFaq(faq._id)}
                                  data-bs-target={`#flush-collapse-${index}`}
                                  // aria-expanded="false"
                                  aria-expanded={openFaq === faq._id}
                                  aria-controls={`flush-collapse-${index}`}
                                >
                                  <p>{faq.question}</p>
                                  {/* <div >
                              <p>{faq.question}</p>
                              {openFaq === faq._id ?(
                             ""
                              ):(<p className="faqfont">
                              { faq.answer?faq.answer.slice(0,100)+"......": "Answer not available"}
                              </p>)}
                              </div> */}

                                  <span className="icon">
                                    {/* <i className="fas fa-chevron-down"></i> */}
                                    <i
                                      className={`fas fa-chevron-${
                                        openFaq === faq._id ? "up" : "down"
                                      }`}
                                    ></i>
                                  </span>
                                </button>
                              </h2>
                              <div
                                id={`flush-collapse-${index}`}
                                className="accordion-collapse collapse"
                                aria-labelledby={`flush-heading-${index}`}
                                data-bs-parent="#accordionFlushExample"
                              >
                                {openFaq === faq._id && (
                                  <div className="accordion-body-faq faqfont">
                                    {faq.answer || "Answer not available"}
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="faq2">
                          <span className="faq_cate_span">
                           {t(" NoFAQsAvailableForThisCategory")}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQ;
